import { useRouteHistory } from "context/RouteHistoryContext"
import { useNavigate } from "react-router-dom"

const BackButton = ({
  fallback = "/dashboard",
  iconClass = "fas fa-arrow-left",
  className,
}) => {
  const navigate = useNavigate()
  const historyStack = useRouteHistory()

  const handleBack = () => {
    if (historyStack.length > 1) {
      navigate(-1) // Go to previous route
    } else {
      navigate(fallback) // Otherwise fallback
    }
  }

  // Determine label dynamically from previous route
  const label = (() => {
    if (historyStack.length > 1) {
      const previousRoute = historyStack[historyStack.length - 2] // second-to-last in stack
      const parts = previousRoute.split("/").filter(Boolean)
      const lastPart = parts[parts.length - 1]
      // Convert slug to readable label
      return `Back to ${
        lastPart?.replace(/-/g, " ").replace(/\b\w/g, l => l.toUpperCase()) ||
        "Dashboard"
      }`
    } else {
      return "Back to Dashboard"
    }
  })()

  return (
    <button
      type="button"
      onClick={handleBack}
      className={className || "btn btn-primary btn-lg rounded-pill shadow-sm"}
    >
      {iconClass && <i className={`${iconClass} me-2`}></i>}
      {label ?? ""}
    </button>
  )
}

export default BackButton
